import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material';
import { MapaService } from '../../../services/mapa.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { IGNICIONES } from './../../../../../_entities/estados';
import {DatePipe} from '@angular/common';
@Component({
	selector: 'kt-popup-recorrido-historico',
	templateUrl: './popup-recorrido-historico.component.html',
	styleUrls: ['./popup-recorrido-historico.component.scss']
})
export class PopupRecorridoHistoricoComponent implements OnInit {
	public permanentOverlayPopup: Observable<any>;
	public informacionPunto;
	public ignicion;

	constructor(public dialog: MatDialog,
		public mapaService: MapaService,
		private datepipe: DatePipe,
		public dialogRef: MatDialogRef<PopupRecorridoHistoricoComponent>) { }

	ngOnInit() {
		this.obtenerInformacionInicial();
		this.obtenerInformacionPunto();
	}

	obtenerInformacionPunto() {
		this.permanentOverlayPopup = this.mapaService.permanentOverlayPopup();
		this.permanentOverlayPopup.subscribe((info) => {
			this.informacionPunto = info;
		});
	}

	obtenerInformacionInicial() {
		this.informacionPunto = this.mapaService.informacionInicial;
	}

	historicoStreetView() {
		this.mapaService.historicoStreetView();
	}

	public minimizarPopup() {
		this.dialogRef.addPanelClass('displayNone');
	}

	public maximizarPopup() {
		this.dialogRef.removePanelClass('displayNone');
	}

	public cerrarPopup() {
		this.dialogRef.close();
	}


}
